import { useCallback, useRef } from 'react';
import { useQuestionnaireFormContext } from '@/components/Questionnaire/QuestionnaireProvider';
import Button from '@/components/DesignLibrary/Button';
import { AccumulatedModalChanges } from '@/components/Questionnaire/QuestionnaireProvider/QuestionnaireFormProvider/QuestionnaireFormContext';

type Props = {
  rowFieldKey: string;
  onClick: (args: { accumulatedModalChanges: AccumulatedModalChanges, newValue: { _id: string } }) => void;
};

const SaveButton: React.FC<Props> = ({ onClick, rowFieldKey }) => {
  const modalFormContext = useQuestionnaireFormContext();
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  const handleClick = useCallback((): void => {
    const accumulatedModalChanges = modalFormContext.getAccumulatedModalChanges();
    const newValue = modalFormContext.formMethods.getValues(rowFieldKey);
    onClickRef.current({ accumulatedModalChanges, newValue });
  }, [modalFormContext]);

  return (
    <Button
      variant="primary"
      size="md"
      onClick={handleClick}
    >
      Save
    </Button>
  );
};

export default SaveButton;